import React, { FC } from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import ShortContentCard, {
  ShortContentCardProps,
} from './ShortContentCard';

const SortableShortContent: FC<ShortContentCardProps> = (props) => {
  const {
    isDragging,
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    setActivatorNodeRef,
  } = useSortable({ id: props.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition: transition || undefined,
  };

  return (
    <ShortContentCard
      ref={setNodeRef}
      style={style}
      withOpacity={isDragging}
      dragHandleRef={setActivatorNodeRef}
      dragHandleListeners={listeners}
      {...props}
      {...attributes}
    />
  );
};

export default SortableShortContent;
